import { Component, OnInit, OnDestroy } from '@angular/core';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';
import { SupersetDashboardService } from './service/superset-dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HomeService } from '../shared/services/home.service';

@Component({
  selector: 'app-superset-dashboard',
  templateUrl: './superset-dashboard.component.html',
  styleUrls: ['./superset-dashboard.component.scss']
})
export class SupersetDashboardComponent implements OnInit{
  constructor(
    public sidePanelService:SidePanelService,
    public supersetDashboardService:SupersetDashboardService,
    public homeService:HomeService,
  ) { }

  

  ngOnInit(): void {
    this.sidePanelService.initSideDrawer('superset_dashboard');
  }


  

 
}
